
import React from 'react';
import { Loader2 } from 'lucide-react';
import KudosSystem from './kudos/KudosSystem';
import PassionTracker from './PassionTracker';
import UserProfiles from './UserProfiles';
import MotivationCorner from './MotivationCorner';
import ReferralCard from './ReferralCard';
import PitchPlayground from '../pitch/PitchPlayground';

interface DesktopDashboardProps {
  userName: string;
  loadingStats: boolean;
  userStats: {
    followers: number;
    following: number;
  };
  statsFetchFailed?: boolean;
}

const DesktopDashboard: React.FC<DesktopDashboardProps> = ({
  userName,
  loadingStats
}) => {
  return (
    <main className="flex-grow bg-muted/30">
      <div className="container px-4 py-8">
        <header className="mb-8">
          <h1 className="text-4xl font-bold mb-2">Welcome, {userName}!</h1>
          <p className="text-xl text-muted-foreground">
            {loadingStats ? (
              <span className="flex items-center gap-2">
                <Loader2 className="h-4 w-4 animate-spin" /> Loading...
              </span>
            ) : (
              "Your journey to personal growth starts here."
            )}
          </p>
        </header>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="space-y-6">
            <PassionTracker />
            <PitchPlayground />
            <MotivationCorner />
          </div>
          <div className="space-y-6">
            <KudosSystem />
            <ReferralCard />
            <UserProfiles />
          </div>
        </div>
      </div>
    </main>
  );
};

export default DesktopDashboard;
